<template>
<div>
  <div style="padding-top: 10px;padding-bottom: 10px;">
    <el-switch
        style="display: block"
        v-model="this.audit.content"
        @change="enabledChange()"
        :active-value="'1'"
        :inactive-value="'0'"
        active-color="#13ce66"
        inactive-color="#ff4949"
        active-text="开启审核"
        inactive-text="关闭审核">
    </el-switch>
  </div>

</div>
</template>

<script>
export default {
  name: 'DynamicAudit',
  data () {
    return {
      activeName: 'SysAdmin',
      audit:{
        content:''
      }
    }
  },
  mounted () {
    this.initAudit()
  },
  methods: {
    initAudit(){
      this.getRequest('/system/basic/dynamic').then(resp => {
        if (resp) {
          this.audit = resp
        }
      })
    },
    enabledChange(){
      this.getRequest('/system/basic/dynamic/audit').then(resp => {
        if (resp) {
          this.initAudit()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
